var Products;
(function (Products) {
    Products["perks"] = "PERKS";
    Products["recognition"] = "RECOGNITION";
    Products["medical"] = "MEDICAL";
    Products["insights"] = "INSIGHTS";
})(Products || (Products = {}));
export default Products;
